'use strict';
import { Injectable, Inject, Output, EventEmitter } from 'ng-metadata/core';
import { SearchService } from '../search.service';
import { ConfigurationUtil } from '../../nddUtils/configurationUtil.service';
import { ResultUtil } from '../../nddUtils/resultUtil.service';
import { UserSessionManagerService } from '../../security/userSessionManager.service';
import { FavoritesService } from '../../favorites/favorites.service';
import { JwtUtilService } from '../../security/jwtUtil.service';
import { STATE_NAMES } from '../../primoExplore/primoExploreStates.module';
const difference = require('lodash/difference');
const indexOf = require('lodash/indexOf');
const uniqBy = require('lodash/uniqBy');
const filter = require('lodash/filter');
const map = require('lodash/map');
const get = require('lodash/get');
const includes = require('lodash/includes');
import { PrimoResponse } from '../../infra/dataStructures/PrimoResponses/doc.interfcae';
import { ChangeLangService } from "../../infra/lang/changeLang.service";
import { FilterInstitution } from "../../nddUtils/filterInstitution.service";
import { getInstitutionCode, getVid } from '../../appConfig/appConfigForward';
import { SearchUtil } from '../../nddUtils/searchUtil.service';
import { FullViewPageService } from "../fullView/fullViewPage/fullViewPage.service";
import { preventStateReload } from "../../infra/annotations";
import { TemplateUtil } from "../../nddUtils/templateUtil.service";
import { Cheetah } from '../cheetah.service';
import { SearchStateService, ISearchObject } from './../searchState.service';
import { MappingTablesCache } from '../../mappingTablesCache/mappingTablesCache.service';
import { getAttributesMap } from '../../appConfig/appConfigForward';
import { PartiallyTranslatedFieldsUtil } from '../../nddUtils/partiallyTranslatedFieldsUtil.service';
import { DatabasesService } from '../../journals/databases.service';

var angular: angular.IAngularStatic = require('angular');
const remove = require('lodash/remove');

@Injectable()
export class BriefResultService {

    private isChosen: Object[] = [];
    private chosen: Object[] = [];
    private searchChosen: Object[] = [];
    private items: Object[] = [];
    private searchItems: Object[] = [];
    private searchChosenItems: PrimoResponse.IDoc[] = [];
    private chosenItems: PrimoResponse.IDoc[] = [];
    private _selectAll: boolean = false;
    private _enableOrDisableToolBar: boolean = false;
    private _openedFromTopActionBar: boolean = false;
    private UPDATE_FAVORITES_URL: string;
    private SHOW_PNX_IN_XML_URL: string;
    private GET_ITEM_API_URL: string;
    private _isInGetFrbrEvent: boolean;
    private allOoRegexp = new RegExp('\\$\\$O(.*),?', 'g');
    //private allOoRegexp = new RegExp('\\$\\$O(.*?),', 'g');
    private showPins = {};
    private _currentFullViewIndex;
    private _actionsLoadingFinished: boolean = true;
    private _isFullViewOverlayOpen: boolean = false;
    private _pinnedToFav: boolean = false;
    public serviceId: string;
    public selectedSearchRecordsCounter: number = 0;
    /*@Output() loadNextResultsEvent = new EventEmitter<void>();*/
    private ENABLE_CDI_ATTRIBUTES: string = "display_CDI_secondary_RT";
    public warningAttributesOrder= new Map<string, number>([
        ["retracted_publication", 0],
        ["withdrawn_publication", 1],
        ["retraction_notice", 2],
        ["withdrawal_notice", 3],
        ["publication_exp_concern", 4],
        ["publication_addendum", 5],
        ["publication_corrigendum", 6]

    ]);
    public regularAttributesOrder= new Map<string, number>([
        ["review_article", 0],
        ["primary_source", 1],
        ["preprint", 2],
        ["online_first", 3],
        ["open_educational_resource",4]
    ]);


    private parametersHandling = {
        'incrementByBulkSize': (paramValue) => {
            let bulkSize = this.resultUtil.updatedBulkSize;
            return Number(paramValue) + bulkSize;
        },
        'decrementByBulkSize': (paramValue) => {
            let bulkSize = this.resultUtil.updatedBulkSize;
            return Number(paramValue) - bulkSize;
        }
    }



    constructor(private configurationUtil: ConfigurationUtil,
                private searchService: SearchService,
                private searchStateService: SearchStateService,
                private resultUtil: ResultUtil,
                private cheetah: Cheetah,
                @Inject('$http') private $http,
                @Inject('$location') private $location: ng.ILocationService,
                private userSessionManagerService: UserSessionManagerService,
                private jwtUtilService: JwtUtilService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                private searchUtil: SearchUtil,
                private favoritesService: FavoritesService,
                private fullViewPageService: FullViewPageService,
                private templateUtil: TemplateUtil,
                @Inject('restBaseURLs') private restBaseURLs,
                @Inject('$state') private $state,
                @Inject('$q') private $q: ng.IQService,
                @Inject('$rootScope') private $rootScope: ng.IRootScopeService,
                private changeLangService: ChangeLangService,
                private filterInstitution: FilterInstitution,
                private mappingTablesCache: MappingTablesCache,
                private partiallyTranslatedFieldsUtil: PartiallyTranslatedFieldsUtil,
                private databasesService : DatabasesService,
                @Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService) {

        this.selectedSearchRecordsCounter = 0;
        this.UPDATE_FAVORITES_URL = restBaseURLs.favoritesBaseURL + '/';
        this.SHOW_PNX_IN_XML_URL = restBaseURLs.showPnxInXmlUrl;
        this.GET_ITEM_API_URL = restBaseURLs.pnxBaseURL;
        this.userSessionManagerService.signInObservable.subscribe(() => {
            this.buildJsonOdIdsAndPins();
        });
    }


    handleDialogHide(perviousUrl, item) {
        this.isFullViewOverlayOpen = false;
        window.onpopstate = undefined;
        //if dialog is closed because we want to get frbr don't restore previous url since we are adding facet to it
        if (this.isInGetFrbrEvent) {
            return;
        }
        let isRemote = item.context === 'MetaLib';
        //let firstRecord = this.briefResultService.searchResults()[0];
        //let replaceResults = firstRecord.context != 'MetaLib';
        let preventReloadPgae = this.$state.current.name == STATE_NAMES.FAVORITES
            || this.$state.current.name == STATE_NAMES.ORGANIZATION_LIST
            || isRemote;
        if (preventReloadPgae) {
            this.restorePreviousUrlPreventReload(perviousUrl);
        } else {
            this.restorePreviousUrl(perviousUrl);
        }
        //in case we are in favorites and need to change the url (record that was removed with unique label). in users only
        if ((this.$state.current.name == STATE_NAMES.FAVORITES) && this.jwtUtilService.isSignedIn() && this.favoritesService.needToChangeUrl) {
            this.favoritesService.needToChangeUrl = false;
            this.favoritesService.getItemsFromServer();
        }

        //return focus on chosen element after closing dialog (full view overlay)
        let recordId = get(item, 'pnx.control.recordid[0]');
        if (recordId) {
			let focusElem = document.getElementById('SEARCH_RESULT_RECORDID_' + recordId);
            if (focusElem) {
            	focusElem.focus();
        	}
        }
    }

    @preventStateReload
    private restorePreviousUrlPreventReload(perviousUrl) {
        this.$location.url(perviousUrl);
    }

    private restorePreviousUrl(perviousUrl) {
        this.$location.url(perviousUrl);
    }

    public changeFullDisplayUrl(item) {
        let newUrl = this.templateUtil.getFullDeepLinkAbsPath(item);
        this.preventDialogClose = true;
        this.verifyUrlDocIdIsUpdated(item);
        let listener;
        listener = this.$rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState, fromParams) => {
            event.preventDefault();
            listener();
            listener = this.$rootScope.$on('$locationChangeStart', (event) => {
                event.preventDefault();
                listener();    //this unregisters the event listener so we can revert to previous url once dialog is closed
            });
        });
    }
    
    @preventStateReload
    public verifyUrlDocIdIsUpdated(item){
        this.$location.search('docid', this.searchService.getRecordId(item.pnx.control));
    }

    /**
     * The first step for parsing brief result display lines
     *
     * @param item The item to be parsed, contains the PNX
     * @param isCollectionDiscoveryCollection
     */
    async parseDisplayLines(item, isCollectionDiscoveryCollection?: boolean) {
        let isFrbrGenericNotPC: boolean = this.resultUtil.isFrbr(item) && this.searchService.getFrbrDisplay() === 1
            && item.context !== 'PC' && this.isGenericRecord(item) && !this.isFavoriteState() && this.resultUtil.isMultipleVersions(item);
        let result;
        if (this.$state.current.name === 'servicesPage') {
            let resultView: Object[];
            if (this.configurationUtil.isSuprima()) {
                resultView = [{"delimiter": ",", "items": "title"}, {
                    "delimiter": "; ",
                    "items": "creator,contributor"
                }, {"delimiter": ",", "items": "creationdate"}, {
                    "delimiter": ",",
                    "items": "identifier"
                }, {"delimiter": ",", "items": "ispartof"}];
            } else {
                resultView = [{"delimiter": ",", "items": "title"}, {
                    "delimiter": ";",
                    "items": "creator,creationdate"
                }, {"delimiter": ",", "items": "identifier"}, {"delimiter": ",", "items": "ispartof"}];
            }
            result = await Promise.all(resultView.map((conf, index) => this.parseLineUnbound(item, conf, index)));
        }
        else if (isCollectionDiscoveryCollection) {
            // When collection discovery flag set in MT the fields should be hard coded to title and description and not according to the view configuration
            let config = [{delimiter: ' ', items: 'title'}, {delimiter: ' ', items: 'description'}];
            result = await Promise.all(config.map((conf, index) => this.parseLineUnbound(item, conf, index)));
        }
        else if (isFrbrGenericNotPC) {
            // Generic record and generic is configured - local
            result = await Promise.all(this.configurationUtil.getBriefResultFrbrGenericConfiguration().resultview.map((conf, index) => this.parseLineUnbound(item, conf, index)));
        } else {
            if (this.configurationUtil.getBriefResultConfiguration()) {
                result = await Promise.all(this.configurationUtil.getBriefResultConfiguration().resultview.map((conf, index) => this.parseLineUnbound(item, conf, index)));
            }
        }
        return filter(result, (r) => r.values.length > 0);
    }

    /**
     * The second step for parsing brief result display lines
     *
     * @param item The item to be parsed, contains the record PNX
     * @param conf The view brief results display lines configuration
     * @param index
     */
    async parseLineUnbound(item, conf, index) {
        let delimiter = conf.delimiter;
        let sameFieldDelimiter = index === 0 ? '<br/>' : delimiter;
        let keys = conf.items.split(',');
        let values = await Promise.all(keys.filter(key => !(this.databasesService.isDBSearch() && key==='description'))
                                            .map((key, index) => this.getValueObjectUnbound(item, delimiter, sameFieldDelimiter, key, index)));
        return {
            values: values.filter((e: any) => e.values),
            delimiter: delimiter
        };
    }

    /**
     * The third and final step for parsing brief result display lines
     *
     * @param item The item to be parsed, contains the record PNX
     * @param delim The configured delimiter between 2 fields in the same line
     * @param sameFieldDelim The configured delimiter between 2 values of the same field
     * @param key The field key
     * @param index
     */
    async getValueObjectUnbound(item, delim, sameFieldDelim, key, index): Promise<any> {
        let values = item.pnx.display[key] || item.pnx.display[key.toLowerCase()];
        if (!values) {
            return {
                codes: [''],
                values: values,
                text: values,
                key: key,
                clazz: 'media-' + key
            };
        }

        // Determine whether this field requires translation
        let isToTranslate = false;
        let localFieldsWithUseTranslation = this.configurationUtil.getFieldsWithUseTranslation();
        if (includes(localFieldsWithUseTranslation, key)) {
            isToTranslate = true;
        }

        // Translate the field if needed
        values = await Promise.all(values.map((value) => this.handleFieldTranslations(value, isToTranslate)));

        //values (item.pnx.display[key]) will always be an array
        values = values.map((source) => this.remove$$OValues(source));
        values = this.filterInstitution.filterAndNormalizeData(item, values);
        let orgArr = values;
        let del = this.defaultDelimiter;
        let is$$Containd = (angular.isArray(values) && values.filter(a => a.indexOf('$$') > -1 && !a.startsWith('$$DEI')).length > 0);
        let hasCodes: boolean = false;

        // Configure the delimiter between values of the same field
        if (this.configurationUtil.getBackendSystem() === 'suprima') {
            del = is$$Containd ? del : delim;
        } else {
            del = is$$Containd ? del : sameFieldDelim;
        }

        let joinedValues = (angular.isArray(values)) ? values.join(del) : values;

        // Handle special cases where field codes are involved
        if (key === 'source') {
            joinedValues = this.parseSourceCodes(orgArr);
            hasCodes = true;
        } else if (['identifier', 'description', 'relation',].indexOf(key) > -1 || this.isLocalFieldWithCodeValue(key, joinedValues, del)) {
            joinedValues = this.parseCodes(joinedValues);
            hasCodes = true;
        }

        // Translate codes if there are any
        if (hasCodes) {
            joinedValues.codes = await Promise.all(joinedValues.codes.map((code) => this.getCodeTranslation(code, key)));
        }

        return {
            codes: hasCodes ? joinedValues.codes : [''],
            values: hasCodes ? joinedValues.values : [joinedValues],
            text: hasCodes ? this.calculateTextPerCodeAndValue(joinedValues) : [joinedValues],
            key: key,
            clazz: 'media-' + key
        };
    }

    isGenericRecord(item) {
        if (this.getSearchObject().facets) {
            let facetNames = this.getSearchObject().facets.map((facet, index, arr) => facet.name);
            return facetNames.indexOf('frbrgroupid') === -1
        }
        return true;
    }

    getSearchObject() {
        return this.searchService.getSearchObject();
    }

    private async handleFieldTranslations(value: string, isToTranslate: boolean): Promise<string> {
        if (isToTranslate) {
            if (this.partiallyTranslatedFieldsUtil.isPartiallyTranslated(value)) {
                return await this.partiallyTranslatedFieldsUtil.parsePartiallyTranslatedField(value);
            } else {
                return await this.$translate(value.toLowerCase(), {}, undefined, value);
            }
        } else if (this.partiallyTranslatedFieldsUtil.isPartiallyTranslated(value)) {
            return this.partiallyTranslatedFieldsUtil.removeTranslationTags(value);
        }
        return value;
    }

    private async getCodeTranslation(code: string, key: string): Promise<string> {
        // if there is a code, we need to translate it, in case of 'source' we need to translate it twice
        if (code) {
            let defaultTranslation = '';
            if (key === 'source') {
                defaultTranslation = code.replace('fulldisplay.datasource.', ' ');
            }
            let translation = await this.$translate(code, [], '', defaultTranslation);
            if (key === 'source') {
                return await this.$translate(translation, [], '', translation);
            } else {
                if (key === 'identifier') {
                    translation = translation + ' ';
                }
                return translation;
            }
        } else {
            return code;
        }
    }

    private isLocalFieldWithCodeValue(key: string, joinedValues: string, del: string): boolean {
        if (key.indexOf('lds') === 0 && joinedValues.split(del).every((value) => value.match(/\$\$C.*\$\$V/g))) {
            return true;
        }
        return false
    }

    private calculateTextPerCodeAndValue(joinedValues) {
        let text = [];
        joinedValues.values.forEach((value: string, index: number) => {
            text.push(joinedValues.codes[index] + ' ' + value);
        });
        return text;
    }

    addUserFavorite(item) {
        let payload = this.buildPaylodOfAdd(item);
        return this.$http.post(this.UPDATE_FAVORITES_URL, payload);
    }

    private buildPaylodOfAdd(item) {
        let obj = this.getPayloadObj(item);
        let payload = {
            'add': {
                'records': [
                    obj
                ]
            }
        };
        return payload;
    }

    addUserFavoritesFewRecords(items) {
        let payload = this.buildPaylodOfAddFewRecords(items);
        return this.$http.post(this.UPDATE_FAVORITES_URL, payload);
    }

    private buildPaylodOfAddFewRecords(items) {
        let addRecords = [];
        items.forEach((item) => {
            addRecords.push(this.getPayloadObj(item));
        });

        let payload = {
            'add': {
                'records': addRecords
            }
        }
        return payload;
    }



    getPayloadObj(item){
        let context = item.context;
        let recordId = item.recordId;
        if(item.pnx) {
            recordId = this.getRecordId(item);
        }
        if (context === undefined) {
            if (recordId.startsWith('TN_')) {
                context = 'PC';
            }
            else if (recordId.startsWith("RS_")) {
                context = "SP";
            } else {
                context = 'L';
            }
        }
        return {
            'recordId': recordId,
            'context': context,
            'pnx': item.pnx,
            'institutionCode': item.institutionCode
        }
    }
    getRecordId(item){
        return get(item,'pnx.control.recordid[0]');
    }






    removeUserFavorite(recordId) {
        let payload = this.buildPaylodOfRemove(recordId);
        //console.log(payload);
        return this.$http.post(this.UPDATE_FAVORITES_URL, payload);
    }

    private buildPaylodOfRemove(recordId) {
        let payload = {
            'delete': {
                'records': [
                    { 'recordId': recordId }]
            }
        };
        return payload;
    }

    removeUserFavoritesFewRecords(records) {
        let payload = this.buildPaylodOfRemoveFewRecords(records);
        //console.log(payload);
        return this.$http.post(this.UPDATE_FAVORITES_URL, payload);
    }

    private buildPaylodOfRemoveFewRecords(records) {
        let deleteRecords = [];
        let obj;
        for (let i = 0; i < records.length; i++) {
            obj = { 'recordId': records[i] };
            deleteRecords.push(obj);
        }
        let payload = {
            'delete': {
                'records': deleteRecords
            }
        };
        return payload;
    }

    saveJsonOdIdsAndPins(recordId, showPin) {
        this.showPins[recordId] = showPin;
    }

    saveJsonsOdIdsAndPins(records, showPin) {
        records.map((record) => this.saveJsonOdIdsAndPins(record, showPin));
    }

    getShowPinForRecordId(recordId) {
        return this.showPins[recordId];

    }

    get selectAll() {
        if (this.checkIfAllSelected()) {
            this._selectAll = true;
        }
        else {
            this._selectAll = false;
        }
        return this._selectAll;
    }

    set selectAll(select) {
        this._selectAll = select;
    }

    get enableOrDisableToolBar() {
        return this._enableOrDisableToolBar;
    }

    set enableOrDisableToolBar(bool) {
        this._enableOrDisableToolBar = bool;
    }


    get openedFromTopActionBar() {
        return this._openedFromTopActionBar;
    }

    set openedFromTopActionBar(isOpened) {
        this._openedFromTopActionBar = isOpened;
    }

    saveJsonOdIdsAndIfChosen(recordId, chosen) {
        this.isChosen[recordId] = chosen;
    }

    saveJsonOdIdsAndItems(item, chosen) {

        if (chosen) {
            this.chosenItems.push(item);
            this.searchChosenItems.push(item);
            this.selectedSearchRecordsCounter++;
        }
        else {
            this.removeElementFromItemsList(item);
        }
    }

    removeElementFromItemsList(item: PrimoResponse.IDoc) {
        for (let i = 0; i < this.chosenItems.length; i++) {
            if (this.chosenItems[i].pnx.control.recordid[0] === item.pnx.control.recordid[0]) {
                this.chosenItems.splice(i, 1);
                i = this.chosenItems.length;
            }
        }
        for (let i = 0; i < this.searchChosenItems.length; i++) {
            if (this.searchChosenItems[i].pnx.control.recordid[0] === item.pnx.control.recordid[0]) {
                this.searchChosenItems.splice(i, 1);
                i = this.searchChosenItems.length;
            }
        }
    }

    getIfChosenForRecordId(recordId) {
        return this.isChosen[recordId] === undefined ? false : this.isChosen[recordId];
    }

    getChosenRecords() {
        this.chosen.length = 0;
        let fullList = this.favoritesService.getFullList();

        if (fullList !== undefined) {
            let recordIds = this.returnArrayOfRecordIds(fullList);
            for (let i = 0; i < recordIds.length; i++) {
                if (this.isChosen[recordIds[i]]) {
                    this.chosen.push(recordIds[i]);
                }
            }
        }
        return this.chosen;
    }

    getSearchChosenRecords() {
        this.searchChosen.length = 0;
        let fullList = this.searchResults();

        if (fullList !== undefined) {
            for (let i = 0; i < fullList.length; i++) {
                if (this.isChosen[fullList[i].pnx.control.recordid[0]]) {
                    this.searchChosen.push(fullList[i]);
                }
            }
        }
        return this.searchChosen;
    }

    checkIfAllSelected() {
        let fullList = this.favoritesService.getFullList();
        if (fullList !== undefined && fullList.length !== 0) {
            let recordIds = this.returnArrayOfRecordIds(fullList);
            if (((difference(recordIds, this.getChosenRecords())).length) === 0) {
                return true;
            }
        }
        return false;
    }

    returnArrayOfRecordIds(fullList) {
        return fullList.map((element) => this.returnRecordIds(element));
    }

    chooseAll() {
        let fullItemList = angular.copy(this.favoritesService.getFullList());
        fullItemList.map((item) => this.saveJsonOdIdsAndIfChosen(this.returnRecordIds(item), this._selectAll));
        if (this._selectAll) {
            if (this.isGuest()) {
                this.chosenItems = fullItemList;
            }
            else {
                this.favoritesService.isSelectAllDone = false;
                let fetchTimer = setTimeout(() => {
                    this.favoritesService.isFetchingAllItems = true;
                }, 3000);
                let isSelectAllSavedRecords = this.favoritesService.getTotalItems() === fullItemList.length;
                this.favoritesService.returnPnxForRecords((this.isSuprima() && isSelectAllSavedRecords) ? 'All' : fullItemList).then((response: { data: PrimoResponse.IDoc[] }) => {
                    let data = response.data;
                    data = data.filter(this.favoritesService.filterObject);
                    data.forEach((item, index, array) => item.context = 'U');
                    //   this.chosenItems = data;
                    this.chosenItems = this.chosenItems.concat(data);
                }).finally(() => {
                    clearTimeout(fetchTimer);
                    this.favoritesService.isSelectAllDone = true;
                    this.favoritesService.isFetchingAllItems = false;
                });
            }
        }
        else {
            this.chosenItems = [];
        }
    }

    searchChooseAllVisible() {
        let fullItemList = angular.copy(this.searchResults());
        fullItemList.map((item) => this.saveJsonOdIdsAndIfChosen(item.pnx.control.recordid[0], this._selectAll));

        // In case the user used choose top max button and then used the unselect all option
        // it means we need to unselect all background records and not just the visible records
        if (!this._selectAll) {
            let fullBackList = this.searchChosenItems;
            fullBackList.map((item) => this.saveJsonOdIdsAndIfChosen(item.pnx.control.recordid[0], this._selectAll));
        }

        this.searchChosenItems = (this._selectAll) ? fullItemList : [];
    }

    checkSearchIfAllSelected() {
        let fullList = this.searchResults();
        if (fullList !== undefined && fullList.length !== 0) {
            if (((difference(fullList, this.getSearchChosenRecords())).length) === 0) {
                return true;
            }
        }
        return false;
    }

    checkIfJumpedByPageNav() {
        if (this.$state.params['offset']){
            return this.$state.params['offset'] != 0;
        }
        return false;
    }

    loadAndSelectTopMax(TopMaxNum: number) {

        // Calculate args params according to exist loaded records
        let args = this.getSearchObject();
        let currLimit = args.to;
        let numOfRecordsToLoad = TopMaxNum - currLimit;
        let currBulkSize = args.bulkSize;

        // In case we need to load more records in oder to select top 50
        if (numOfRecordsToLoad > 0) {
            args.offset = args.offset + args.bulkSize;
            args.bulkSize = numOfRecordsToLoad;
            this.searchService.needToRender = false;
            this.searchService.search(args, false).then(() => {
                this.selectTopMax(TopMaxNum);
            }).finally(() => {
                // Reset offset and bulk size for next regular load more action
                args.bulkSize = currBulkSize;
                args.offset = args.offset - args.bulkSize;
                this.searchService.needToRender = true;
            });
        }
    }

    // Reset user selection and select 50 top max records or less (depends on total results)
    selectTopMax(TopMaxNum: number) {
        let fullItemList = this.searchResults();
        fullItemList = fullItemList.concat(this.searchStateService.getTempResultList());
        fullItemList.map((item) => this.saveJsonOdIdsAndIfChosen(item.pnx.control.recordid[0], false));
        fullItemList = fullItemList.slice(0, TopMaxNum);
        fullItemList.map((item) => this.saveJsonOdIdsAndIfChosen(item.pnx.control.recordid[0], true));
        this.searchChosenItems = fullItemList;
    }

    getSearchChosenItems() {
        return this.searchChosenItems;
    }

    getChosenItems() {
        //using temp array in order not to change 'this.items' reference, causing a problem in angular $digest
        let newArray = this.chosenItems.filter((item) => {
            return (indexOf(this.chosen, item.pnx.control.recordid[0]) > -1);
        });
        newArray = uniqBy(newArray, 'pnx.control.recordid[0]');
        this.items.length = 0;
        // copy by value to this.items
        for (let i = 0; i < newArray.length; i++) {
            this.items.push(newArray[i]);
        }
        return this.items;
    }

    /*full list is different in it's content between user and guest
     user - record ids
     guest - item*/
    returnRecordIds(element) {
        if ((this.isGuest()) && (element.pnx !== undefined)) {
            return element.pnx.control.recordid[0];
        }
        return element;
    }

    getIsChosen() {
        return this.isChosen;
    }

    isGuest() {
        return this.jwtUtilService.isGuest();
    }

    buildJsonOdIdsAndPins() {
        this.showPins = {};
        let userName = this.jwtUtilService.getDecodedToken().user;
        if (!userName) {
            return;
        }
        this.userSessionManagerService.createOrGetUserArea(userName).then((data) => {
            this.userSessionManagerService.area = data;
            for (let i = 0; i < this.userSessionManagerService.area.length; i++) {
                let area = this.userSessionManagerService.area[i];
                if (this.isGuest()) {
                    this.showPins[(<PrimoResponse.IDoc>area).pnx.control.recordid[0]] = true;
                }
                else {
                    this.showPins[(<string>area)] = true;
                }
            }
        });

    }

    resetShowPin() {
        this.showPins = {};
    }

    public remove$$OValues(value) {
        let matches = value.match(this.allOoRegexp);
        if (matches) {
            for (let i = 0; i < matches.length; i++) {
                value = value.replace(matches[i], '');
            }
            value = value.replace(/\$\$O(.*)/, '');
        }
        return value;
    }

    private parseSourceCodes(value) {
        let parsedObj = { codes: [], values: [] };
        value.forEach((res, index) => {
            res = res.replace('$$V', '');
            res = 'fulldisplay.datasource.' + res;
            parsedObj.codes.push(res);
            parsedObj.values.push('')
        });
        return parsedObj;
    }

    private parseCodes(value) {
        if (value.indexOf('$$C') === -1) {
            return { codes: [''], values: [value.replace(/\$\$./g, ' ')] };
        }
        let parsedObj = { codes: [], values: [] };
        let values = value.split('$$C');
        for (let i = 1; i < values.length; i++) {
            value = values[i].split('$$V');
            parsedObj.codes.push('fulldisplay.constants.' + value[0].trim());
            let combinedValues = '';
            for (let j = 1; j < value.length; j++) {
                combinedValues += value[j];
            }
            parsedObj.values.push(combinedValues);
        }
        return parsedObj;
    }

    pinToFavoritesFromToolBar(records) {
        let user = this.jwtUtilService.getDecodedToken().user;
        if (this.isGuest()) {
            this.pinToFavoritesForGuest(user, records);
        }
        else {
            this.pinToFavoritesForUser(user, records);
        }
    }

    pinToFavoritesForGuest(user, records) {
        this.userSessionManagerService.createOrGetUserArea(user).then((data) => {
            this.userSessionManagerService.area = data;

            // Update the selected rows array according to comparison between exist local forage array to the selected records array
            records = records.filter(function (newItem) {
                return !data.find(function (existItem) {
                    return existItem.pnx.control.recordid[0] == newItem.pnx.control.recordid[0];
                });
            });

            this.userSessionManagerService.extendUserArea(records).then(() => {
                records.map((item) => this.saveJsonOdIdsAndPins(item.pnx.control.recordid[0], true));
                this.favoritesService.getItemsFromLocalForage(user);
            });
        });
    }

    pinToFavoritesForUser(user, records) {
        this.pinnedToFav = false;
        this.userSessionManagerService.createOrGetUserArea(user).then((data) => {
            this.userSessionManagerService.area = data;
            let recordIds = records.map((record) => { return record.pnx.control.recordid[0]; });
            this.addUserFavoritesFewRecords(records).then(() => {
                this.userSessionManagerService.extendUserArea(recordIds).then(() => {
                    recordIds.map((id) => this.saveJsonOdIdsAndPins(id, true));
                    this.favoritesService.getItemsFromServer();
                });
            }).finally(() => {
                this.pinnedToFav = true;
            });
        });
    }

    unpinFavoritesFromToolBar(records) {
        let user = this.jwtUtilService.getDecodedToken().user;
        this.favoritesService.unpinFromFav = true;
        if (this.isGuest()) {
            this.unpinFavoritesForGuest(user, records);
        }
        else {
            this.unpinFavoritesForUser(user, records);
        }
    }

    unpinFavoritesForGuest(user, records) {
        this.userSessionManagerService.createOrGetUserArea(user).then((data) => {
            this.userSessionManagerService.area = data;
            this.userSessionManagerService.removeArrayOfRecords(records).then(() => {
                this.saveJsonsOdIdsAndPins(records, false);
                //have to reload again the page in order to make this record disappear
                this.favoritesService.getItemsFromLocalForage(user);
            });
        });
    }

    unpinFavoritesForUser(user, records) {
        this.userSessionManagerService.createOrGetUserArea(user).then((data) => {
            this.userSessionManagerService.area = data;
            this.removeUserFavoritesFewRecords(records).then(() => {
                this.userSessionManagerService.removeArrayOfRecords(records).then(() => {
                    this.saveJsonsOdIdsAndPins(records, false);//aaaaaaaaaaaaaaaaa
                    //have to reload again the page in order to make this record disappear
					if(this.favoritesService.searchPerformed) {
						records.forEach((recordId) => {
							this.favoritesService.recordsId = remove(this.favoritesService.recordsId, (n) => { return n != recordId;});
						});
						this.favoritesService.totalItems = this.favoritesService.recordsId.length;
						this.favoritesService.updateLabelsFromAPI(true);
						this.favoritesService.getFirstBulkOfAllItems();
					} else {
                    	 this.favoritesService.getItemsFromServer();
					}
                   
                });
            });
        });
    }

    resetIsChosen() {
        this.isChosen = [];
        this.chosenItems = [];
        this.searchChosenItems = [];
        this.selectedSearchRecordsCounter = 0;
    }

    set isInGetFrbrEvent(value) {
        this._isInGetFrbrEvent = value;
    }

    get isInGetFrbrEvent() {
        return this._isInGetFrbrEvent;
    }

    set currentFullViewIndex(value) {
        this._currentFullViewIndex = value;
    }

    get currentFullViewIndex() {
        return this._currentFullViewIndex;
    }

    set actionsLoadingFinished(value) {
        this._actionsLoadingFinished = value;
    }

    get actionsLoadingFinished() {
        return this._actionsLoadingFinished;
    }

    isServicePageState() {
        if (this.$state.current.name === "servicesPage") {
            return true;
        }
        return false;
    }

    isFavoriteState() {
        if (this.$state.current.name == STATE_NAMES.FAVORITES) {
            return true;
        }
        return false;
    }

    getShowBookmark() {
        if (this.configurationUtil.getBackendSystem() === 'suprima') {
            if (this.configurationUtil.getSummonOverAlma() === true) {
                return false;
            }
        }
        return true;
    }

    isSuprima() {
        return this.configurationUtil.isSuprima();
    }


    /*Hack for PRM-33685 New UI: Hebrew titles aligned incorrectly, as can be viewed by the brackets order*/

    public changeStringDirectionToRtl(strArray) {

        if (this.changeLangService.direction == 'ltr') {
            return false;
        }

        if (!strArray || strArray.length === 0) {
            return false;
        }

        let isCombineString = false;
        let isWithEnglishString = false;
        const combiningHalfMarksregexp = /[ \t.,`@)(%~><}{\[\]\\\/:;_&^#$%'\"\+!?*=#|-]/g;
        const stringWithEN = /[a-z]/i;

        strArray.forEach((item) => {
                return item.text && item.text.length && item.text.forEach((text) => {
                    isCombineString = isCombineString || combiningHalfMarksregexp.test(text);
                    isWithEnglishString = isWithEnglishString || stringWithEN.test(text);
                })
            }
        );

        return isCombineString && isWithEnglishString;
    }

    public dontChangeStringDirectionToRtl(strArray) {

        if (this.changeLangService.direction == 'ltr') {
            return false;
        }

        if (strArray.length === 0) {
            return false;
        }


        let isNotCombineString = false;
        const combiningHalfMarksregexp = /[ \t.,`@)(%~><}{\[\]\\\/:;_&^#$%'\"\+!?*=#|-]/g;
        const stringWithEN = /[a-z]/i;

        isNotCombineString = combiningHalfMarksregexp.test(strArray) || stringWithEN.test(strArray);

        return isNotCombineString;
    }

    get isFullViewOverlayOpen() {
        return this._isFullViewOverlayOpen;
    }

    set isFullViewOverlayOpen(newValue) {
        this._isFullViewOverlayOpen = newValue;
    }

    get pinnedToFav() {
        return this._pinnedToFav;
    }

    set pinnedToFav(pinned) {
        this._pinnedToFav = pinned;
    }

    public ShowPnxInXmlUrl(item) {
        let product = 'primo-explore/';
        if (this.configurationUtil.getBackendSystem() === 'suprima') {
            product = 'discovery/';
        }
        let absUrl = this.$location.absUrl().substring(0, this.$location.absUrl().indexOf(product) - 1);

        let showPnxInXmlUrl = '';
        if (item) {

            let recordInstitutionCode = getInstitutionCode();
            let path = this.templateUtil.getDeepLinkPath(item);
            let params = this.templateUtil.prmParseKeyValue(path.substr(path.indexOf('?') + 1));

            let url = this.fullViewPageService.createUrl(params['context'], params['docid'], params['id'], params['inst'], params['search_scope'], params['adaptor'], params['isFrbr'], params['showPnx']);

            url = url.replace(this.GET_ITEM_API_URL, absUrl + this.SHOW_PNX_IN_XML_URL);
            showPnxInXmlUrl = url + '&inst=' + recordInstitutionCode + '&showPnx=true&jwtAsParam=' + this.jwtUtilService.getJwtFromLocalStorage();
        }
        return showPnxInXmlUrl;
    }

    public getTextDirection(text) {

        let envDirection = this.changeLangService.direction;
        let textDirectionClass = (envDirection === 'rtl') ? 'direction-rtl' : 'direction-ltr';

        let ltrChars = 'A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02B8\u0300-\u0590\u0800-\u1FFF' + '\u2C00-\uFB1C\uFDFE-\uFE6F\uFEFD-\uFFFF';
        let rtlChars = '\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC';
        let rtlDirCheck = new RegExp('^[^' + ltrChars + ']*[' + rtlChars + ']');

        if (envDirection == 'ltr' && rtlDirCheck.test(text)) {
            textDirectionClass = 'direction-rtl';
        }

        if (envDirection == 'rtl' && !rtlDirCheck.test(text)) {
            textDirectionClass = 'direction-ltr';
        }

        return textDirectionClass;
    }

    // Full view overlay - next and previous arrows
    public isFirstRecord() {
        return (this._currentFullViewIndex === 1);
    }

    public isLastRecord() {
        if (!this.searchService.getResultObject() || !this.searchService.getResultObject().info || !this.searchService.getResultObject().info.total) {
            return false;
        }
        const currentIndex = this._currentFullViewIndex;
        const totalIndex = this.searchService.getResultObject().info.total;

        return (!currentIndex || currentIndex === totalIndex);

    }


    public isLastRecordFav() {
        const currentIndex = this._currentFullViewIndex;
        const totalIndex = this.favoritesService.getTotalItems();

        return (!currentIndex || currentIndex === totalIndex)
            ? true
            : false;
    }


    public searchResults() {
        return this.searchService.getResultObject().data;
    }

    public currentResultIndex(replaceResults = false) {
        let cur = this._currentFullViewIndex;
        let bulkSize = this.resultUtil.updatedBulkSize;

        // Ensure we will not get negative result
        if (cur > Number(this.$state.params['offset'] | 0)) {
            cur = cur - Number(this.$state.params['offset'] | 0) - 1;
        }else{
            cur = cur - 1;
        }
        return replaceResults ? cur % bulkSize : cur;
    }

    public getNextRecord(replaceResults = false) {

        return this.$q((resolve, reject) => {
            if (this.isLastResultInCurrentBulk(replaceResults)) {
                if (replaceResults) {
                    this.previousUrl = this.handleParamInUrl(this.previousUrl, 'offset', 'incrementByBulkSize',0);
                }
                this.searchService.nextResults(replaceResults).then(data => {
                    this._currentFullViewIndex++;
                    resolve(this.currentResultIndex(replaceResults));
                }), error => {
                    reject();
                }
            }
            else {
                this._currentFullViewIndex++;
                resolve(this.currentResultIndex(replaceResults));
            }

        });

    }


    public getNextRecordFav() {
        if(this._currentFullViewIndex % this.favoritesService.getBulkSize() === 0 )
            this.favoritesService.nextResults();
        return this._currentFullViewIndex++;
    }

    public getNextRecordJSearch() {
        this.searchResults();
        this._currentFullViewIndex++;
    }

    public getNextRecordDBSearch() {
        this.searchResults();
        this._currentFullViewIndex++;
    }

    public isFirstResultInCurrentBulk(replaceResults = false) {

        let currentResultIndex = this.currentResultIndex(replaceResults);
        if (replaceResults) {
            let bulkSize = this.resultUtil.updatedBulkSize;
            return (currentResultIndex % bulkSize === 0);
        } else {

            return (currentResultIndex  === 0);
        }
    }

    public isLastResultInCurrentBulk(replaceResults = false) {
        let currentResultIndex = this.currentResultIndex(replaceResults); 
        let searchResults = this.searchResults();
        if (currentResultIndex === searchResults.length - 1) {
            return true;
        }
        return false;
    }

    public getPreviousRecord(replaceResults = false) {
        return this.$q((resolve, reject) => {
            if (this.isFirstResultInCurrentBulk(replaceResults)) {
                if (replaceResults) {
                    this.previousUrl = this.handleParamInUrl(this.previousUrl, 'offset', 'decrementByBulkSize',0);
                }
                this.searchService.previousResults(replaceResults).then(data => {
                    this._currentFullViewIndex--;
                    resolve(this.currentResultIndex(replaceResults));
                }), error => {
                    reject();
                }
            }
            else {
                this._currentFullViewIndex--;
                resolve(this.currentResultIndex(replaceResults));
            }

        });


    }

    public isRelatedItemsConfiguredPrimo(vid: string): boolean {
        let config = this.mappingTablesCache.findByProperties('Related Items', { source1: vid });
        if (config.length > 0) {
            return config[0].target === 'Yes';
        }
        return true;
    }

    public isRelatedItemsConfigured(vid: string): boolean {
        if (this.isSuprima()) {
            return getAttributesMap()['relatedItemsActive'] == true;
        }
        return this.isRelatedItemsConfiguredPrimo(vid);
    }

    public isSearchInProgress(){
        return this.searchStateService.isSearchInProgress();
    }

    public getIndex(replaceResults, data) {
        if (!replaceResults) {
            return data;
        }
        let bulkSize = this.resultUtil.updatedBulkSize;

        return (data % bulkSize);


    }

    get defaultDelimiter(): string {
        return this.isSuprima()? '%#%#' : ';';
    }

    private handleParamInUrl(url, param, func, defaultValue) {
        let splittedUrlParameters = url.split('?');
        let urlParameters = splittedUrlParameters[1];
        let parameters = urlParameters.split('&');
        let parameterFound = false;
        for (let i=0; i<parameters.length; i++) {
            if (parameters[i].startsWith(param)) {
                parameterFound = true;
                let splittedParam =  parameters[i].split('=');
                splittedParam[1] = this.parametersHandling[func](splittedParam[1]);
                parameters[i] = splittedParam.join('=');
            }

        }
        splittedUrlParameters[1]=parameters.join('&');
        if (!parameterFound && angular.isDefined(defaultValue)) {
            splittedUrlParameters[1] = splittedUrlParameters[1] + '&'+ param + '=' + this.parametersHandling[func](defaultValue);
        }
        return splittedUrlParameters.join('?');

    }

    get isCdiAttributesEnabledInBO(){
        return this.mappingTablesCache.findByProperties(this.mappingTablesCache.tables.VIEW_PROPERTIES,
            {source1: getVid(), source2: this.ENABLE_CDI_ATTRIBUTES, target: 'true'}).length > 0;
    }

    public performSearchRelatedBibs(item){
        let params = {    
            vid: getVid(),
            mode: 'authority',
            offset: 0,
            originatingSystem: get(item, 'pnx.control.originatingSystem'),
            originatingSystemId: get(item, 'pnx.control.originatingSystemId'),
            prevAuthQuery: this.$stateParams['authorityQuery'],
            prevAuthField: this.$stateParams['searchField']
        };
        let stateName = STATE_NAMES.SEARCH;
        return this.$state.go(stateName, params, {reload: stateName});
    }

}





// WEBPACK FOOTER //
// ./src/main/webapp/components/search/briefResult/briefResult.service.ts